import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { SlotOptionType, Terminal } from 'icreate/common/models/slot';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SensorCableTagPrintAPIService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getFuPrintFile(vesselId: string, fcuNums: Set<number>): Promise<any> {
        const fcuNumsArray = [...fcuNums];
        return await lastValueFrom(
            this.http.get(`${this.domain}/api/sensor-cable-print`, {
                params: { vesselId, fcuNums: fcuNumsArray },
                responseType: 'blob',
            })
        );
    }

    async getSelectedFuPrintFile(vesselId: string, fuNums: Set<number>): Promise<any> {
        const fuNumsArray = [...fuNums];
        return await lastValueFrom(
            this.http.get(`${this.domain}/api/sensor-cable-print/fu`, {
                params: { vesselId, fuNums: fuNumsArray },
                responseType: 'blob',
            })
        );
    }

    async getSlotPrintFile(
        vesselId: string,
        slotId: string,
        slotType: SlotOptionType,
        terminal?: Terminal
    ): Promise<any> {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/sensor-cable-print/slot`,
                { terminal },
                {
                    params: { vesselId, slotId, slotType },
                    responseType: 'blob',
                }
            )
        );
    }
}
